import {Button, Tooltip} from 'antd';

const IconBtn = ({onClick, children, loading = false, color, TooltipText}) => {
    return (

        <Tooltip title={TooltipText}><Button loading={loading} className={`defIconBtn ${color} `}
                                             onClick={onClick}
        >
            <div> {children}</div>
        </Button></Tooltip>

    );
};

export default IconBtn;